/**
 * Enum representing record specific watch options.
 * @description
 * This enum defines the options for watching changes to a given record.
 * It is used in conjunction with the notifications system and allows more granular control
 * over the specific records that the user is interested in.
 */
export enum UserWatchOptionEnum {
	/**
	 * Receive notifications for any changes to the record regardless of the notification preferences.
	 */
	WATCH = 'watch',
	/**
	 * Only receive notifications which are configured in notification preferences in the settings.
	 */
	DEFAULT = 'default',
	/**
	 * Do not receive any notifications for this record regardless of the notification preferences.
	 */
	IGNORE = 'ignore',
}
